import { render, staticRenderFns } from "./TechSpecs.vue?vue&type=template&id=49183df0"
import script from "./TechSpecs.vue?vue&type=script&lang=js"
export * from "./TechSpecs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports